export default "__VITE_ASSET__BwySCmy4__"